var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppIconGprInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 70",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1240,
    height: 1240,
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "App Rounded"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 7",
    width: 1240,
    height: 1240,
    rx: 212,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M803.86 522.566a53.522 53.522 0 00-11.481-14.574 55.114 55.114 0 00-17.128-10.176 57.053 57.053 0 00-20.647-3.818H500.478V860.49h83.37v-112.8h170.756a57.351 57.351 0 0020.647-3.818 52.92 52.92 0 0017.128-10.487 58.485 58.485 0 0011.481-14.531 34.088 34.088 0 004.314-16.631v-162.8a35.437 35.437 0 00-4.314-16.857zm-78.673 55.95v88.649c0 .27-.156.6-.184.88-.5 5.846-2.526 10-6.131 12.388a17.082 17.082 0 01-9.508 2.441h-125.9V560.3h125.9c8.685 0 13.723 4.087 15.255 12.1.1.582.241 1.149.326 1.8.014.184.014.411.043.61.1 1.022.2 2.086.2 3.221z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 53",
    d: "M225.921 494h-38.08a37.662 37.662 0 00-16.756 3.863 45.981 45.981 0 00-14.187 10.582c-.746.789-1.335 1.809-2.024 2.685q-11.006 12.664-11.731 30.426c-.057.8-.143 1.594-.143 2.426v156.309a50.732 50.732 0 003.891 19.6c.273.617.618 1.177.933 1.809.431.962.919 1.9 1.45 2.829a51.7 51.7 0 007.624 11.286 46.078 46.078 0 0014.187 10.609c5.313 2.57 11.6 4.968 17.445 4.968h188.931v25.9c0 11.3-5.628 16.958-16.943 16.958H227.429v66.236h183.072c13.985 0 25.917-3.862 35.666-11.544q14.625-11.587 14.632-32.594V494zm151.211 112.845v59.057c0 11.616-5.184 17.948-15.522 17.948l-50.758-.014h-67.93c-10.339 0-15.493-4.753-15.493-16.4v-88.562q0-17.511 15.493-17.532H361.61q15.507 0 15.522 17.532z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M920.157 494h-30.552a36.18 36.18 0 00-14.728 3.586 46.339 46.339 0 00-13.789 10.317 51.367 51.367 0 00-9.819 15.625 48.482 48.482 0 00-3.828 19.126V747.84h82.023V577.105c0-11.868 5.28-17.845 15.8-17.845h151.903V494z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconGprInsights);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconGPRInsights.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };